import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Evidencer Record Query</h3>
          <p>Query and view blockchain evidence and legal records</p>
          <p className="copyright">&copy; {new Date().getFullYear()} Web3 Legal Engineering. All rights reserved.</p>
        </div>
        
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li><a href="/">Home</a></li>
            <li><a href="/#query">Query Records</a></li>
            <li><a href="/#view">View Records</a></li>
            <li><a href="/#verify">Verify</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Legal Tools</h4>
          <ul className="footer-links">
            <li><a href="https://hero.evidencer.io/" target="_blank" rel="noopener noreferrer">SmartLaw</a></li>
            <li><a href="https://www.evidencer.io/" target="_blank" rel="noopener noreferrer">LexAutomatico</a></li>
            <li><a href="https://hero.evidencer.io/" target="_blank" rel="noopener noreferrer">Web3 Legal Tools</a></li>
            <li><a href="https://evidencer.freeweb3.com" target="_blank" rel="noopener noreferrer">Evidencer Portal</a></li>
          </ul>
        </div>
        
        <div className="footer-section">
          <h4>Connect</h4>
          <div className="social-links">
            <a href="https://x.com/tenfinney" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <i className="social-icon twitter">𝕏</i>
            </a>
            <a href="https://github.com/lexautomatico" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <i className="social-icon github">GitHub</i>
            </a>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>Powered by <a href="https://www.base.org" target="_blank" rel="noopener noreferrer">Base Network</a></p>
        <div className="legal-links">
          <a href="/terms">Terms of Service</a>
          <a href="/privacy">Privacy Policy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;